export function getQueryParamsFromUrl(
  url: string,
): Record<string, string> | undefined {
  const toReturn: Record<string, string> = {};
  if (url.indexOf('?') < 0) {
    return undefined;
  }
  const queryParamsString = url.substr(url.indexOf('?') + 1);
  const splitted: string[] = queryParamsString.split('&');
  for (let indexSplit = 0; indexSplit < splitted.length; indexSplit++) {
    const thisParam = splitted[indexSplit];
    const thisParamKey = thisParam.substr(0, thisParam.indexOf('='));
    const thisParamVal = thisParam.substr(thisParam.indexOf('=') + 1);
    toReturn[thisParamKey] = thisParamVal;
  }
  return toReturn;
}
